import useCurrentUser from "./useCurrentUser";

const useUserHasRequiredRole = (roles: string[]) => {
  const { currentUser } = useCurrentUser();
  return !roles.length || Boolean(currentUser?.roles?.some(role => roles.includes(role)));
};

export default useUserHasRequiredRole;
